import { Spring, useSpring, animated } from '@react-spring/web'
import React from 'react'
import { useState, useRef } from 'react'


export default function EmailSymbol() {
    const ref = useRef(null);
    const [xys, set] = useState([0, 0, 1]);

    const calc = (x, y, rect) => [
        -(y - rect.top - rect.height / 2) / 5,
        (x - rect.left - rect.width / 2) / 5,
        1.4
    ];

    const transformImg = (x, y, s) =>
        `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`;


    const config = {
        mass: 1,
        tension: 170,
        friction: 26,
        clamp: false,
        precision: 0.01,
        velocity: 0,
        easing: (t) => t
    }

    const fadeStyles = useSpring({
        from: {
            opacity: 0,
            x: 2200,
        },
        to: {
            opacity: 1,
            x: 0,
        },
        config: { tension: 220, friction: 150 },
    });

    const props = useSpring({ xys, config: config });

    return (
        <div className="email" ref={ref}>
            <animated.div style={fadeStyles}>
            <animated.div
                style={{ transform: props.xys.to(transformImg) }}
                onMouseLeave={() => set([0, 0, 1])}
                onMouseMove={(e) => {
                    const rect = ref.current.getBoundingClientRect();
                    set(calc(e.clientX, e.clientY, rect));
                }}>
                <a href="mailto: nictuzio@gmail.com" target={"_blank"}>
                    <img title="Email me at nictuzio@gmail.com!" src={require('../../imgs/email.png')}></img>
                </a>
            </animated.div>
            </animated.div>
        </div>
    )
}
